import Holidays from "date-holidays";
import moment, { Moment } from "moment";

import { DayWithHolidaysForCal, DayWithHolidaysForCalMobile } from "../types";

const hd = new Holidays("IT");
hd.setHoliday("06-24", "San Giovanni");

export const year = moment().year();

export const today = () => {
  const _today = moment().format("YYYY-MM-DD");
  // console.log("date _today", _today);
  return _today;
};

export const getStartEndOfMonth = (date: Moment) => {
  const startOfMonth = moment(date).startOf("month");
  const endOfMonth = moment(date).endOf("month");

  return {
    startOfMonth,
    endOfMonth
  };
};

export const getStartEndOfMonthFormatted = (date: Moment) => {
  const startOfMonth = moment(date).startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment(date).endOf("month").format("YYYY-MM-DD");

  return {
    startOfMonth,
    endOfMonth
  };
};

export const getStartEndOfMonthExpanded = (date: Moment) => {
  const startOfMonth = moment(date)
    .startOf("month")
    .subtract(15, "d")
    .format("YYYY-MM-DD");
  const endOfMonth = moment(date)
    .endOf("month")
    .add(15, "d")
    .format("YYYY-MM-DD");

  return {
    startOfMonth,
    endOfMonth
  };
};

export const combineDateAndTime = (
  date?: string,
  time?: string,
  format: string | null = null
) => {
  if (format) {
    return time ? moment(`${date} ${time}`).format(format) : undefined;
  }

  return time ? moment(`${date} ${time}`) : null;
};

export const getHolidays = (year: number) => {
  return hd.getHolidays(year);
};

export const getHolidaysForCal = <
  T extends DayWithHolidaysForCal | DayWithHolidaysForCalMobile
>(
  year: number,
  type: "web" | "mobile" = "web"
) => {
  const data: T[] = [];
  // console.log("getHolidaysForCal");
  hd.getHolidays(year).forEach((item) => {
    if (item.type === "public") {
      const dayCalendar =
        type === "mobile"
          ? ({
              id: item.name,
              date: moment(item.start).format("YYYY-MM-DD"),
              isHoliday: true
            } as unknown as DayWithHolidaysForCalMobile)
          : ({
              title: item.name,
              start: item.start,
              allDay: true,
              display: "background"
            } as unknown as DayWithHolidaysForCal);
      data.push(dayCalendar as T);
    }
  });
  return data;
};

export const isHoliday = (date: Date) => {
  return hd.isHoliday(date);
};

export const roundToXDigits = (value: number, digits: number) => {
  value = value * Math.pow(10, digits);
  value = Math.ceil(value);
  value = value / Math.pow(10, digits);
  return value;
};
